import React from 'react';
import webapi from '../../../api/webapi';
import SearchBox from './SearchBox';
import Footer from '../Footer/Footer';
import SearchResult from './SearchResult';
import Header from '../Header/Header';
import Loading from '../modal/Loading';
import EmptyDiv from '../Footer/EmptyDIV';


class Search extends React.Component {
    state = { statments : [] }
    state = { results : [] }
    state = { t_results : [] }
    state = { SearchtabIndex : 0}
    state = { LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}] }
    //state = {LoadingShow : false}

    componentDidMount(){
        this.setState({ SearchtabIndex : 0})
        if (new URLSearchParams(this.props.location.search).get("lang")!=null)
        {
            //console.log('LangFromURL: ',new URLSearchParams(this.props.location.search).get("lang"));
            //console.log('LangFromSubDomain: ',window.location.host.split(".")[0]);
            this.getLanguageInfo(new URLSearchParams(this.props.location.search).get("lang"));
            //console.log(this.state.LanguageInfo);
        }else{
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
            this.getPage();
        }

        //fetch('https://api.ipify.org/?format=json')
        fetch('https://geolocation-db.com/json/')
            .then(response => {
                return response.json();
            }, "jsonp")
            .then(res => {
                //this.setLog('pages/log/Search/visit/'+res.ip.replaceAll('.',','))
                this.setLog('pages/log/Search/visit/'+res.IPv4.replaceAll('.',','))
            })
            .catch(err => this.setLog('pages/log/Search/visit/'+err));
      }

    async setLog(Data) {
        await webapi.post(Data);
    }

    async getLanguageInfo(LanguageCode){
        const responseResultlanguageinfo = await webapi.get('pages/LanguageInfo/'+LanguageCode);
        //console.log(responseResultlanguageinfo.data.length);
        //console.log(responseResultlanguageinfo.data);
        
        if (responseResultlanguageinfo!==undefined && responseResultlanguageinfo.data.length>0)
        {
            this.setState({LanguageInfo:responseResultlanguageinfo.data});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang", responseResultlanguageinfo.data[0].Code);
            document.getElementsByTagName('html')[0].setAttribute("dir", responseResultlanguageinfo.data[0].Direction);
        }
        else
        {
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang","fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
        }
        this.getPage();
    }

    async getPage() {
        if (this.state.LanguageInfo)
        {
            const pageList = await webapi.get('pages/datapages/202/'+this.state.LanguageInfo[0].Code);
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }else{
            const pageList = await webapi.get('pages/datapages/202/fa');
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }
    }


    onSearchButtonClick = async WGBC => {
        this.setState({LoadingShow:true});
        var Type="";

        this.setState({results:''});
        this.setState({t_results:''});

        switch(this.state.SearchtabIndex){
            case 0: Type="Pahlavi";break;//پهلوی
            case 1: Type="Transcription";break;//آوانویسی
            case 2: Type="Transliteration";break;//حرف‌‌‌ نویسی
            case 3: Type="Translation";break;//معنی فارسی
            case 4: Type="WordRoot";break;//بن واژه
            default: break;
        }

        this.setState({word:WGBC.Word})
        //console.log('sentenceresult/'+Type+'/'+WGBC.Word+'/'+WGBC.BookGroup+'/'+WGBC.Book+'/'+WGBC.Chapter)

        const responseResult = await webapi.get('sentenceresult/'+Type+'/'+WGBC.Word+'/'+WGBC.BookGroup+'/'+WGBC.Book+'/'+WGBC.Chapter);
        this.setState({results:responseResult.data});

        //console.log(responseResult.data)

        const responset_Result = await webapi.get('sentencetresult/'+Type+'/'+WGBC.Word+'/'+WGBC.BookGroup+'/'+WGBC.Book+'/'+WGBC.Chapter);
        this.setState({t_results:responset_Result.data});

        //console.log(responset_Result.data)

        this.setState({LoadingShow:false})
    };

    onSelectTab = (val) => {
        //console.log(val);
        this.setState({
            SearchtabIndex: val  
        })
        this.setState({results:''});
        this.setState({t_results:''});
    }

    render() {
        if (this.state.pageData && this.state.LanguageInfo) {
            return (
                <div>
                    <Header LanguageInfo = {this.state.LanguageInfo}/>
                    <div className="container-fluid" id="innerpage_row_1">
                        <div className="container">
                            <h1 id="page_title">{this.state.pageData.length!==0 && this.state.pageData[0].F202!== undefined?this.state.pageData[0].F202:202/*جستجوی واژه*/}</h1>
                            <h2 id="page_title_dek">{this.state.pageData.length!==0 && this.state.pageData[0].F20200!== undefined?this.state.pageData[0].F20200:20200/*فهرست واژگان و تنوع و بسامد واژه‌های فارسی میانه*/}</h2>
                            <hr className="halfwidth" />
                        </div>
                    </div>
                    

                    <SearchBox  SelectedtabIndex={this.state.SearchtabIndex} 
                                onSelectTab={this.onSelectTab} 
                                onSearchButtonClick={this.onSearchButtonClick}
                                pageData={this.state.pageData}
                                Lang = {this.state.LanguageInfo[0].Code}
                    />

                    <br />
                    {
                        (
                            (this.state.statments && this.state.statments.length>0)
                            ||
                            (this.state.results && this.state.results.length>0)
                        )
                        ?
                            <SearchResult   statments={this.state.statments} 
                                            results={this.state.results} 
                                            t_results={this.state.t_results} 
                                            word={this.state.word}
                                            pageData={this.state.pageData}
                                            SearchtabIndex={this.state.SearchtabIndex}
                            />
                        :
                            <EmptyDiv />
                    }
                    <Footer   Lang = {this.state.LanguageInfo[0].Code}/>
                    <Loading LoadingShow={this.state.LoadingShow} />
                </div>
                
        )
    }
    else
    {
        return (
            <div></div>
        )
    }
    }
 }

 export default Search;